<template>
  <v-card light>
    <v-card-text>

      <v-row>
        <v-col cols="3" :class="{'pb-0':errors!=null}">
          <v-combobox :items="possibleInstitutions" :hide-details="errors==null" outlined item-color="white"
                      item-text="entityname" item-value="entityname"
                      :error-messages="errors != null ? errors.institution : null"
                      :label="$t('components.qualification_measure.institution_text_field')"
                      v-model="qualification.institution" @change="qualificationItemChanged()"
                      append-icon=""
                      @update:search-input="searchInstitution($event)"></v-combobox>
        </v-col>
        <v-col cols="3" :class="{'pb-0':errors!=null}">
          <v-combobox :items="possibleDegrees" :hide-details="errors==null" outlined item-color="white"
                      item-text="entityname" item-value="entityname"
                      :error-messages="errors != null ? errors.degree : null"
                      :label="$t('components.qualification_measure.qualification_text_field')"
                      v-model="qualification.degree" @change="qualificationItemChanged()"
                      append-icon=""
                      @update:search-input="searchDegree($event)"
          ></v-combobox>
        </v-col>
        <v-col :class="{'pb-0':errors!=null}">
          <v-combobox :items="possibleSpecialities" :hide-details="errors==null" outlined item-color="white"
                      item-text="entityname" item-value="entityname"
                      :error-messages="errors != null ? errors.speciality : null"
                      :label="$t('components.qualification_measure.major_text_field')"
                      v-model="qualification.speciality" @change="qualificationItemChanged()"
                      append-icon=""
                      @update:search-input="searchSpeciality($event)"
          ></v-combobox>
        </v-col>
        <v-col :class="{'pb-0':errors!=null}">
          <v-autocomplete cache-items light :items="years" :hide-details="errors==null" outlined item-color="white"
                          :label="$t('components.qualification_measure.completion_year_text_field')"
                          :error-messages="errors != null ? errors.graduated : null"
                          :placeholder="$t('components.qualification_measure.in_process')"
                          v-model="qualification.graduated" @change="qualificationItemChanged()"></v-autocomplete>
        </v-col>
        <v-col :class="{'mb-5':errors!=null}" cols="1"
               style="display: flex; justify-content: center; align-items: center; flex-wrap: wrap">

          <v-btn @click="removeQualification()" color="black" icon v-if="!saving">
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <template v-if="saving">
          <v-progress-circular
              :width="2"
              :size="20"
              color="black"
              indeterminate
              class="mr-2"
          ></v-progress-circular>
            Saving...
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import {debounce} from "../../../../lib/rate";

  export default {
    name: "QualificationStrip",
    props:{
      years: {
        type: Array,
        required: true
      },
      value : {
        type: Object,
        required: true
      },
      initialSpecialities:{
        type: Array,
        default: ()=>{
          return [];
        }
      },
      initialInstitutions:{
        type: Array,
        default: ()=>{
          return [];
        }
      },
      initialDegrees:{
        type: Array,
        default: ()=>{
          return [];
        }
      },
    },
    data(){
      return {
        possibleSpecialities: [],
        possibleInstitutions: [],
        possibleDegrees: [],
        qualification:{},
        errors:null,
        ready:false,
        saving:false,
      }
    },
    watch:{
      'qualification.graduated': function(newVal,oldVal){
        this.$emit('graduatedChanged',{newVal,oldVal});
      }
    },
    methods:{
      //TODO DEBOUNCE
      searchInstitution(val) {
        if (!this.ready || !val || val.trim() === '' || ''+val.length < 2) {
          this.possibleInstitutions = [];
          return;
        }

        this.getEntities('institution',val);
      },
      searchSpeciality(val) { //MAJOR
        if (!this.ready || !val || val.trim() === '' || ''+val.length < 2) {
          this.possibleSpecialities = [];
          return;
        }

        this.getEntities('speciality',val);
      },
      searchDegree(val) { //QUALIFICATION
        if (!this.ready || !val || val.trim() === '' || ''+val.length < 2) {
          this.possibleDegrees = [];
          return;
        }

        this.getEntities('degree', val);
      },
      getEntities(type,val){
        this.$http.post('entitytypes/qualification/column/'+type+'/entities', {search:val}).then(
          (res)=>{
            if(type==='institution'){
              this.possibleInstitutions = res.data;
            }
            if(type==='speciality'){
              this.possibleSpecialities = res.data;
            }
            if(type==='degree'){
              this.possibleDegrees = res.data;
            }
          }
        );
      },
      removeQualification() {
        this.$emit('delete');
      },
      qualificationItemChanged(){
        const keys = ['institution', 'degree', 'speciality', 'graduated'];

        let shouldSave = true;

        keys.forEach(key => {
          if (key !== 'graduated' && (this.qualification[key] == null || (this.qualification[key] != null && this.qualification[key].toString().trim() === ''))) {
            shouldSave = false;
            return;
          }
        });

        this.errors = null;

        if (shouldSave) {

          let qualification = this.qualification;
          if(typeof qualification.institution === 'object' && qualification.institution !== null){
            qualification.institution = qualification.institution.entityname;
          }
          if(typeof qualification.speciality === 'object' && qualification.speciality !== null){
            qualification.speciality = qualification.speciality.entityname;
          }
          if(typeof qualification.degree === 'object' && qualification.degree !== null){
            qualification.degree = qualification.degree.entityname;
          }

          this.saving = true;

          //ONLY UPDATE
          if (this.qualification.qualificationid != null && !(isNaN(this.qualification.qualificationid))) {

            this.$http.patch('person/qualifications/' + this.qualification.qualificationid, qualification).then(
              (res) => {
                this.qualification = res.data.data;
                setTimeout(()=>{
                  this.saving = false;
                },800);
              },
              () => {
                this.saving = false;
                //TODO catch error
              },
            );
          }
          //create new
          else {

            qualification.qualificationid = null;

            this.$http.post('person/qualification', qualification).then(
              (res) => {
                this.$nextTick(()=>{
                  this.qualification = res.data.data;
                  setTimeout(()=>{
                    this.saving = false;
                  },800);
                });

              },
              () => {
                this.saving = false;
                //TODO catch error
              },
            );
          }

          this.$set(this.qualification,'id',this.value.id);

          this.$emit('input',this.qualification);
        }
      },
    },
    mounted(){
      this.qualification = this.value;

      this.possibleSpecialities = this.initialSpecialities;
      this.possibleInstitutions = this.initialInstitutions;
      this.possibleDegrees = this.initialDegrees;

      this.getEntities=debounce(this.getEntities,600);

      setTimeout(()=>{
        this.ready=true;
      },50);

    }
  }
</script>

<style scoped>

</style>
